import Sidebar from "../Sidebar/Sidebar";
import { Outlet } from "react-router-dom";

const Layout = () => {
    return (
        <div className="flex">
            <Sidebar />
            <div className="h-[100dvh] flex-1 overflow-auto">
                <Outlet />
            </div>
        </div>
    );
};

export default Layout;
